import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/payjet_logo_neu__white_quadratisch.png'


const _hoisted_1 = { class: "hidden lg:flex lg:flex-shrink-0 rounded-2xl mr-3" }
const _hoisted_2 = { class: "flex flex-col w-20" }
const _hoisted_3 = { class: "flex-1 flex flex-col min-h-0 overflow-y-auto bg-indigo-600 rounded-xl" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = {
  "aria-label": "Sidebar",
  class: "py-6 flex flex-col items-center space-y-3"
}
const _hoisted_6 = { class: "nav-item-text py-4 rounded-lg text-indigo-200 hover:bg-indigo-700 bg-indigo-600 rounded-r-xl" }
const _hoisted_7 = { class: "flex-shrink-0 flex pb-5" }
const _hoisted_8 = { class: "flex-shrink-0 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_user_menu = _resolveComponent("user-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-indigo-700 py-4 flex items-center justify-center" }, [
            _createElementVNode("img", {
              alt: "Workflow",
              class: "h-8 w-auto",
              src: _imports_0
            })
          ], -1)),
          _createElementVNode("nav", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.name,
                to: { name: item.name },
                class: _normalizeClass(["flex items-center p-4 rounded-lg text-indigo-200 hover:bg-indigo-700", item.classes])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    "aria-hidden": "true",
                    class: "h-6 w-6"
                  })),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.meta.title), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_user_menu)
          ])
        ])
      ])
    ])
  ]))
}